export default "__VITE_ASSET__53e329a5__"